import React from 'react';
import classes from './AboutUs.module.css';

const AboutUs = () => {
    return (
        <>
            <div className={classes.about__container}>
                <article className={classes.about__left}>
                    <h3 className={classes.about__subtitle}>Why TechStudyGroup?</h3>
                    <h2 className={classes.about__title}>
                        <span className={classes.about__important_text}>TechStudyGroup</span> provides then class for those who likes group study.
                    </h2>
                    <p className={classes.about__content}>
                        Our course is designed in such a way, so that the students will feel it as a group study. Basically the 
                        the coaching or online classs are tightly scheduled and stuck with the theory mostly. Such teaching style is not much fruitfull. 
                        So to make education a fun activity, we designed the course to cater the problem of the particepating group. Completion duration also depends
                         on the group's ability to digest the knowlwdge. Complete course is devided into practical sessions instead of theory.
                        {'\n'}
                        <span className={classes.about__strong_text}>
                            Being the part of TechStudyGroup you will learn without any stress like a game.
                        </span>
                    </p>
                    {/* <a href='#thank_you' className={classes.about__link}>
                        <span>Message for the Indian trading community</span>
                    </a> */}
                </article>
                <div className={classes.about__right}>
                    <figure className={classes.about__figure}>
                        <img alt='About Us' src='banner_programming.jpg' />
                    </figure>
                </div>
            </div>
            <div className={classes.about__background} />
        </>
    );
};

export default AboutUs;
